// extracted by mini-css-extract-plugin
export default {"base":"vp_nr6Ye","dateBlock":"vp_q_DSW","label":"vp_QbU_v","time":"vp_aWPX9","date":"vp_nbkAS","selected":"vp_U5REc","hourBlock":"vp_y0Bnv","hours":"vp_B8tP7","invalid":"vp_YyefD"};